module.exports = __webpack_public_path__ + "static/img/logo29.828be3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo29.jpg
// module id = O5+2
// module chunks = 1